import { render, staticRenderFns } from "./ttshop_integral.vue?vue&type=template&id=8f2c3d14&scoped=true&"
import script from "./ttshop_integral.vue?vue&type=script&lang=js&"
export * from "./ttshop_integral.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_integral.vue?vue&type=style&index=0&id=8f2c3d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2c3d14",
  null
  
)

export default component.exports